import React from 'react';
import PropTypes from 'prop-types';

export default class TreeNode extends React.Component {
  static propTypes = {
    value: PropTypes.string,
  };
}



// WEBPACK FOOTER //
// ./ext/tree-select/src/TreeNode.jsx